const SectionBannerSchema = () => ({
  title: 'AgSUS Section Banner',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['eyebrow', 'title', 'subtitle', 'tone'],
    },
  ],
  properties: {
    eyebrow: {
      title: 'Etiqueta',
      description: 'Texto curto em caixa alta, acima do título.',
    },
    title: { title: 'Título', widget: 'textarea' },
    subtitle: { title: 'Subtítulo', widget: 'textarea' },
    tone: {
      title: 'Tom',
      choices: [
        ['surface', 'Surface (cinza claro, default)'],
        ['cream', 'Cream'],
        ['navy', 'Navy (dark)'],
        ['blue', 'Azul brand'],
      ],
      default: 'surface',
    },
  },
  required: ['title'],
});
export default SectionBannerSchema;
